import React from 'react'
import { useNavigate } from 'react-router-dom'
import './styles.scss'

const Home = () => {
    const navigate = useNavigate();

    const handleContactMeNavigation = ()=>{
        navigate('/contact');        
    }

    return (
        <section id="home" className='home'>
            <div className="home__text-wrapper">
                <h1>Yo! It's Pranav here...
                    <br /> I'm a <span className="home__text-wrapper--highlight">Software Engineer</span> from India.
                </h1>
                <div className='home__contact-me'>
                    <button onClick={handleContactMeNavigation} > Work together!</button>
                </div>
            </div>
        </section>
    )
}

export default Home;